module.exports = __webpack_public_path__ + "img/kachel_BEWEGLICHKEIT_probalance.3d26be18.png";